

export const OPEN_ANNOTATION_EVENT = 'open-annotation-popup';

export const dispatchAnnotationEvent = (data) => {
  const tooltipEvent: any = new CustomEvent(OPEN_ANNOTATION_EVENT, {
    detail: data,
  });
  document.dispatchEvent(tooltipEvent);
};
